import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { auth0Config } from './auth0-config';

export function AuthProvider({ children }) {
  const navigate = useNavigate();

  const onRedirectCallback = (appState) => {
    // Detect if user just signed up (vs logging in) and set flag for post-signup modal
    if (appState?.wasSignup) {
      sessionStorage.setItem('aura_just_signed_up', 'true');
    }
    // After login, return to the page user was on
    // Using navigate instead of window.history.replaceState to ensure React Router re-renders
    navigate(appState?.returnTo || window.location.pathname, { replace: true });
  };

  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={auth0Config.authorizationParams}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
}
